import { mdiChevronDown, mdiInformation } from '@mdi/js';
import Icon from '@mdi/react';
import Image from 'next/image';
import { useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { motion, useReducedMotion } from 'framer-motion';

const DISCLAIMER =
    'Het EDUmake project heeft subsidie ontvangen van de Europese Unie onder overeenkomst: CREA-CROSS-2021- INNOVLAB-Project 101059958. Medegefinancierd door de Europese Unie. De hier geuite ideeën en meningen komen echter uitsluitend voor rekening van de auteur(s) en geven niet noodzakelijkerwijs die van de Europese Unie of het Europese Uitvoerende Agentschap onderwijs en cultuur (EACEA) weer. Noch de Europese Unie, noch het EACEA kan ervoor aansprakelijk worden gesteld.';

const EUCoFunding = ({ className }: { className?: string }) => {
    const reduceMotion = useReducedMotion();

    const disclaimerId = 'EUCoFunding__description';

    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <div
            className={twMerge(
                'group bg-white/80 shadow-inner pt-2',
                className,
            )}
        >
            <button
                className="relative w-full text-start"
                aria-checked={isExpanded}
                role="switch"
                aria-label="Medegefinancierd door de Europese Unie. Open voor meer informatie."
                onClick={() => setIsExpanded(!isExpanded)}
                title={DISCLAIMER}
                aria-describedby={disclaimerId}
            >
                <div className="relative w-[10rem] lg:w-[11rem] aspect-[9/2.35] ms-2 me-auto">
                    <Image
                        src={require('./EUCoFunding.svg')}
                        fill
                        alt="Medegefinancierd door de Europese Unie"
                        aria-describedby={disclaimerId}
                    />
                </div>
                <Icon
                    path={isExpanded ? mdiChevronDown : mdiInformation}
                    size={1}
                    className="absolute top-3 right-4 text-[#1b27ec]"
                />
            </button>
            <motion.p
                id={disclaimerId}
                initial={{
                    height: 0,
                    opacity: 0,
                }}
                animate={{
                    height: isExpanded ? 'auto' : 0,
                    opacity: isExpanded ? 1 : 0,
                    transition: {
                        duration: reduceMotion ? 0 : 0.5,
                    },
                }}
                className={`bg-white font-semibold text-sm ${
                    isExpanded ? 'p-3 pt-1' : 'px-3'
                }`}
            >
                {DISCLAIMER}
            </motion.p>
        </div>
    );
};

export default EUCoFunding;
